module.exports = __webpack_public_path__ + "static/media/20180130_182220.9e6a216f.jpg";